import React from 'react';
import {
  FormikRadioInput as Radio,
  DietActivityLevelType,
} from '@front-activerse/common-components';
import { useTranslator } from '@front-activerse/common-components';

export const ActivityLevel: React.FC = () => {
  const { t } = useTranslator();

  return (
    <>
      <h2 className="mb-4 title-large semi-bold">{t('app.goalSettings.activityLevel.headline')}</h2>

      <Radio name="activityLevel" value={DietActivityLevelType.ACTIVITY_LEVEL_NONE}>
        <strong className="mb-0">{t('app.goalSettings.activityLevel.optionNoActive.title')}</strong>
      </Radio>

      <Radio name="activityLevel" value={DietActivityLevelType.ACTIVITY_LEVEL_LOW}>
        <strong className="mb-0">
          {t('app.goalSettings.activityLevel.optionLowActive.title')}
        </strong>
      </Radio>

      <Radio name="activityLevel" value={DietActivityLevelType.ACTIVITY_LEVEL_MEDIUM}>
        <strong className="mb-0">
          {t('app.goalSettings.activityLevel.optionMediumActive.title')}
        </strong>
      </Radio>

      <Radio name="activityLevel" value={DietActivityLevelType.ACTIVITY_LEVEL_HIGH}>
        <strong className="mb-0">
          {t('app.goalSettings.activityLevel.optionVeryActive.title')}
        </strong>
      </Radio>
    </>
  );
};

export default ActivityLevel;
